/**
 * @fileoverview Styles for table components across the application.
 * This file contains style objects for tables, bullets, and eay tabs.
 * @see {/src/components/ui/tables/Table.tsx}
 * @see {/src/components/ui/tables/TableRender.tsx}
 * @active
 */

import { h_700_14_120_28, h_400_14_135_28 } from "@/styles/fontStyles";

/**
 * @interface TableStyles
 * @description Style objects for table components
 * @active
 */
export interface TableStyles {
  TheadTrTh: Record<string, any>;
  TbodyTrTd: Record<string, any>;
  TbodyTrTdName: Record<string, any>;
  TbodyTrTdEmpty: Record<string, any>;
  TbodyTrTdFirst: Record<string, any>;
}

/**
 * @interface BulletStyles
 * @description Style objects for bullet indicators
 * @active
 */
export interface BulletStyles {
  Box: Record<string, any>;
}

/**
 * @interface EayTabStyles
 * @description Style objects for eay tab components
 * @active
 */
export interface EayTabStyles {
  TheadTrTh: Record<string, any>;
  TbodyTrTd: Record<string, any>;
  TbodyTrTdEmpty: Record<string, any>;
}

/**
 * @constant stylesForTable
 * @description Styles for table components
 * @type {TableStyles}
 * @active
 */
export const stylesForTable: TableStyles = {
  TheadTrTh: {
    h: "30px",
    pt: "2px",
    pb: "10px",
    pr: { base: "8px", md: "30px" },
    borderBottom: "2px solid",
    borderColor: "mainBlue",
    textTransform: "unset",
    ...h_700_14_120_28,
    color: "mainBlue",
  },
  TbodyTrTd: {
    py: "6px",
    pr: { base: "8px", md: "30px" },
    h: "40px",
    borderBottom: "1px solid",
    borderColor: "disabledBg",
    ...h_400_14_135_28,
  },
  TbodyTrTdName: {
    pt: "18px",
    pb: "12px",
    pr: { base: "8px", md: "30px" },
    h: "58px",
    borderBottom: "1px solid",
    borderColor: "transparent",
    ...h_400_14_135_28,
  },
  TbodyTrTdEmpty: {
    pt: "18px",
    pb: "12px",
    pr: { base: "8px", md: "30px" },
    h: "58px",
    borderBottom: "1px solid",
    borderColor: "transparent",
    ...h_400_14_135_28,
  },
  TbodyTrTdFirst: {
    py: "6px",
    pr: { base: "8px", md: "30px" },
    pl: "32px",
    h: "40px",
    borderBottom: "1px solid",
    borderColor: "disabledBg",
    ...h_400_14_135_28,
  },
};

/**
 * @constant stylesForBullet
 * @description Styles for bullet indicators
 * @type {BulletStyles}
 * @active
 */
export const stylesForBullet: BulletStyles = {
  Box: {
    w: "6px",
    h: "6px",
    border: "1px solid",
    borderRadius: "50%",
    mt: "8px",
  },
};

/**
 * @constant stylesForEayTab
 * @description Styles for eay tab components
 * @type {EayTabStyles}
 * @active
 */
export const stylesForEayTab: EayTabStyles = {
  TheadTrTh: {
    h: "30px",
    pt: "2px",
    pb: "10px",
    px: "6px",
    borderBottom: "2px solid",
    borderColor: "mainBlue",
  },
  TbodyTrTd: {
    p: "6px",
    h: "40px",
    borderBottom: "1px solid",
    borderColor: "disabledBg",
  },
  TbodyTrTdEmpty: {
    p: "6px",
    h: "58px",
    borderBottom: "1px solid",
    borderColor: "transparent",
  },
};
